<script setup lang="ts">
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'
import misc403 from '@images/pets/dog.png'
import { useI18n } from 'vue-i18n'
import { getDefaultAuthenticatedRoute } from '@/navigation/vertical'
import { useAuthStore } from '@/stores/auth.store'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const backendMessage = computed(() => String(route.query.message ?? ''))

function isNotAuthorizedTarget(target: any) {
  if (!target)
    return true

  if (typeof target === 'string')
    return target === '/not-authorized'

  return target.name === 'not-authorized' || target.path === '/not-authorized'
}

function goHome() {
  const target = getDefaultAuthenticatedRoute()

  if (isNotAuthorizedTarget(target)) {
    goLogin()
    return
  }

  router.push(target)
}

function goLogin() {
  authStore.logout()
  router.push('/login')
}
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader
      status-code="403"
      :title="t('alkokh.errors.notAuthorizedTitle')"
      :description="backendMessage || t('alkokh.errors.notAuthorizedDesc')"
    />

    <div class="d-flex flex-wrap justify-center gap-3 mb-11">
      <VBtn @click="goHome">
        {{ t('alkokh.errors.backHome') }}
      </VBtn>

      <VBtn
        variant="tonal"
        color="secondary"
        @click="goLogin"
      >
        {{ t('alkokh.errors.goLogin') }}
      </VBtn>
    </div>

    <div class="misc-avatar w-100 text-center">
      <VImg
        :src="misc403"
        alt="error 403"
        :max-height="$vuetify.display.smAndDown ? 350 : 500"
        class="mx-auto"
      />
    </div>

    <img
      class="misc-footer-img d-none d-md-block"
      :src="authThemeMask"
      alt="misc-footer-img"
      height="320"
    >
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc";
</style>
